exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "@media screen and (max-width:480px){.home-background .VueCarousel-slide{visibility:visible;-ms-flex-preferred-size:100%;flex-basis:100%;width:100%}}", "", {"version":3,"sources":["/app/src/components/Home.vue"],"names":[],"mappings":"AACA,oCACA,oCACI,mBAAoB,AACpB,6BAA8B,AAC1B,gBAAiB,AACrB,UAAY,CACf,CACA","file":"Home.vue","sourcesContent":["\n@media screen and (max-width: 480px) {\n.home-background .VueCarousel-slide {\n    visibility: visible;\n    -ms-flex-preferred-size: 100%;\n        flex-basis: 100%;\n    width: 100%;\n}\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":true,"sourceMap":true}!./~/vue-loader/lib/style-compiler?{"id":"data-v-3bc3f2be","scoped":false,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=1!./src/components/Home.vue
// module id = 2010
// module chunks = 40